import { render } from "./TheIssueCreation.vue?vue&type=template&id=193ea11a"
import script from "./TheIssueCreation.vue?vue&type=script&lang=js"
export * from "./TheIssueCreation.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__